import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  ListPanel,
  DeviceWidth,
  BackButton,
  ZeroState,
  getFormattedDateTime,
  Paginator,
} from 'ecs-react-components/dist/index.es';
import { messages } from './MedicalNotes.i18n';
import {
  loadMedicalNotes,
  loadNewMedicalNotesCount,
  setMedicalNoteAsReviewed,
  setTotalNumberOfPages,
  setCurrentPageNumber,
  getMedicalNotePageUrl,
  setMedicalNotePageUrl,
} from '../../redux/modules/medical-notes/medical-notes-middleware';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import MedicalNotesFilters from './MedicalNotesFilters';
import Header from '../../components/Header/Header';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';
import * as actions from '../../redux/modules/medical-notes/medical-notes-action-creator';

const MEDICALNOTES_VIEW_AUDIT_TYPE = 'medicalnotesviewauditevent';
const MEDICALNOTES_VIEW_DETAIL_AUDIT_TYPE = 'medicalnotesviewdetailauditevent';

class MedicalNotes extends React.Component {
  constructor(props) {
    super(props);

    this.listItems = [];
    this.state = {
      isRenderingListView: true,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(callWithLoadingIndicator(
      'MedicalNotes',
      () => this.props.dispatch(loadMedicalNotes(this.props.patientId)))
    )
      .then(() => this.generateListItemsFromMedicalNotes());

    this.props.dispatch(loadNewMedicalNotesCount(this.props.patientId));
    this.props.dispatch(auditRequest(MEDICALNOTES_VIEW_AUDIT_TYPE, this.props.patientId));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.generateListItemsFromMedicalNotes(nextProps.medicalNotes.notes);
  }

  onPageChange = (pageNumber) => {
    this.props.dispatch(setCurrentPageNumber(pageNumber));
    const { patientId, selectedMedicalNoteId, token } = this.props;
    this.props.dispatch(setMedicalNotePageUrl(getMedicalNotePageUrl(patientId, selectedMedicalNoteId, pageNumber, token)));
  }

  getSelectedMedicalNote = () =>
    this.props.medicalNotes.notes
      .find((x) => x.ptMedicalNoteId === this.props.selectedMedicalNoteId)

  generateListItemsFromMedicalNotes(notes = this.props.medicalNotes.notes) {
    this.listItems = notes.filter((value) => !value.isFiltered);
    this.listItems = this.listItems.map((note) => {
      const dateParts = getFormattedDateTime(note.serviceDate, note.serviceDate, this.props.language);
      const serviceDate = dateParts.datePart;
      return {
        heading: note.documentType,
        displayBadge: !note.isReviewedByPatient,
        key: note.ptMedicalNoteId,
        itemId: note.ptMedicalNoteId,
        subText: note.authoredBy ?
          note.authoredBy + ', ' + serviceDate : serviceDate,
        isSelected: note.ptMedicalNoteId === this.props.selectedMedicalNoteId,
      };
    });
  }

  handleListItemClick = (activeIndex) => {
    this.props.dispatch(actions.selectedMedicalNoteChanged(this.listItems[activeIndex].itemId));
    this.props.dispatch(setMedicalNoteAsReviewed(this.props.patientId, this.listItems[activeIndex].itemId))
      .then(() => this.props.dispatch(setTotalNumberOfPages(this.getSelectedMedicalNote().pages.length)))
      .then(() => this.props.dispatch(setCurrentPageNumber(1)))
      .then(() => {
        const medicalNote = this.getSelectedMedicalNote();
        const params = {
          patientId: medicalNote.patientId,
          ptMedicalNoteId: medicalNote.ptMedicalNoteId,
          serviceDate: medicalNote.serviceDate,
          documentType: medicalNote.documentType,
        };
        this.props.dispatch(auditRequest(MEDICALNOTES_VIEW_DETAIL_AUDIT_TYPE, this.props.patientId, params));
      })
      .then(() => {
        const { patientId, selectedMedicalNoteId, currentPageNumber, token } = this.props;
        const medicalNotePageUrl = getMedicalNotePageUrl(patientId, selectedMedicalNoteId, currentPageNumber, token);
        this.props.dispatch(setMedicalNotePageUrl(medicalNotePageUrl));

        if (this.isMobileDevice()) {
          window.location.assign(medicalNotePageUrl);
        }
      });

    if (this.isRenderingCompactListView()) {
      this.state.isRenderingListView = false;
    } else {
      this.props.dispatch(loadNewMedicalNotesCount(this.props.patientId));
    }
  }

  handleBackButtonClick = () => {
    this.setState({ isRenderingListView: true });
  }

  isMobileDevice = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  isCompactView = () => (this.props.windowSize === DeviceWidth.Small.name
      || this.props.windowSize === DeviceWidth.XSmall.name);

  isRenderingCompactListView = () =>
    (this.isCompactView() && this.state.isRenderingListView);

  isRenderingCompactDetailView = () =>
    (this.isCompactView() && !this.state.isRenderingListView);

  extractDocumentTypes(notes) {
    const docTypes = [];

    notes.forEach((note) => {
      if (docTypes.indexOf(note.documentType) === -1) {
        docTypes.push(note.documentType);
      }
    });
    return docTypes;
  }

  extractAuthors(notes) {
    const authors = [];

    notes.forEach((note) => {
      if (authors.indexOf(note.authoredBy) === -1) {
        authors.push(note.authoredBy);
      }
    });
    return authors;
  }

  renderCompactViewBackButton() {
    return (
      <div>
        <BackButton buttonName={messages.page.backButton} onClick={this.handleBackButtonClick} />
      </div>
    );
  }

  renderDocumentTypeLabel() {
    return (
      <div>
        <b>{this.props.selectedMedicalNoteId ? this.getSelectedMedicalNote().documentType : ''}</b><br />
      </div>
    );
  }

  renderHeaderPanel() {
    let header = null;
    if (this.isRenderingCompactListView() || !(this.isRenderingCompactDetailView())) {
      const badgeNumber = this.props.medicalNotes.isNotReviewedByPatientCount;
      header = (
        <Header headerTitle={<FormattedMessage { ...messages.page.title } /> }
          badgeNumber={badgeNumber}
          headerClassName="mb-3"
        />
      );
    }
    return header;
  }

  renderLeftContentPane() {
    return (
      <ListPanel
        items={this.listItems}
        title={messages.listPanel.title}
        selectedIndex={ this.props.selectedMedicalNoteId }
        handleListItemClick={this.handleListItemClick}
        qaTag="MedicalNotesContainer"
        wrapperClassName="col-lg-4 custom-list-wrapper"
      />
    );
  }

  renderZeroState() {
    return (
      <div className="col-lg-8 custom-list-wrapper d-none d-lg-block border border-secondary-subtle p-2" >
        <ZeroState
          zeroStateMessage={ <FormattedMessage { ...messages.page.medicalNotesPresentNoneSelected } /> }
          stateIconCss="fa-regular fa-file-lines"
        />
      </div>
    );
  }

  renderPDFContent() {
    const {
      serviceDate,
      authoredBy,
      noteToPatient,
    } = this.getSelectedMedicalNote();
    const dateParts = getFormattedDateTime(serviceDate, serviceDate, this.props.language);
    return (
      <div className="col-lg-8 custom-list-wrapper d-lg-block border border-secondary-subtle p-2">
        <div className="view-pane overflow-y-hidden">
              <div className="card description-box small mb-3">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6">
                        { this.isCompactView() ? this.renderDocumentTypeLabel() : ''}
                        <FormattedMessage {...messages.page.dateOfServices} />:
                        &nbsp;
                        {this.props.selectedMedicalNoteId ? dateParts.datePart : ''}<br />
                        <FormattedMessage {...messages.page.authoredBy} />:
                        &nbsp;
                        {this.props.selectedMedicalNoteId ? authoredBy : ''}
                    </div>
                      { this.props.totalNumberOfPages > 1 ?
                    <div className="col-6">
                        <Paginator
                          currentPageNumber={ this.props.currentPageNumber }
                          totalNumberOfPages={ this.props.totalNumberOfPages }
                          onPageChange={ this.onPageChange }
                        />
                    </div>
                        :
                        null}
                  </div>
                  <div className="row">
                    <div className="col">
                      <p>
                        <FormattedMessage {...messages.page.remarks} />:
                        &nbsp;
                        {this.props.selectedMedicalNoteId ? noteToPatient : ''}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            <div className="content-container">
              <iframe className="viewPortObject" src={ this.props.currentPageUrl } title="viewport">
              </iframe>
            </div>
        </div>
      </div>
    );
  }

  renderMainContentPane() {
    return (
      (this.props.selectedMedicalNoteId) ? this.renderPDFContent() : this.renderZeroState()
    );
  }

  renderNoMedicalNotesPane() {
    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.noMedicalNotes } /> }
        stateIconCss="fa-regular fa-file-lines"
      />
    );
  }

  renderMedicalNotes() {
    if (this.isRenderingCompactListView()) {
      return (this.renderLeftContentPane());
    }

    if (this.isRenderingCompactDetailView()) {
      return (
        <div>
          {
            this.renderCompactViewBackButton()
          }
          {
            this.renderMainContentPane()
          }
        </div>
      );
    }

    return (
      <div className="row g-0">
        {this.renderLeftContentPane() }
        {this.renderMainContentPane() }
      </div>
    );
  }

  renderFilter() {
    return (
      <div>
        <MedicalNotesFilters
          filteredRows={ this.props.medicalNotes.notes.filter((value) => !value.isFiltered).length }
          allRows={ this.props.medicalNotes.notes.length || 0 }
          filterDocuments={ this.extractDocumentTypes(this.props.medicalNotes.notes) }
          filterAuthors={ this.extractAuthors(this.props.medicalNotes.notes) }
        />
      </div>
    );
  }

  render() {
    return (
      <div className="row" id="medical-notes-content">
        <div className="col">
          { this.renderHeaderPanel() }
          { this.isRenderingCompactDetailView() ? null : this.renderFilter() }
          <LoadingIndicatorContainer loadingKey="MedicalNotes" >
            {
              this.props.medicalNotes.notes.filter((value) => !value.isFiltered).length <= 0 ?
                this.renderNoMedicalNotesPane() :
                this.renderMedicalNotes()
            }
          </LoadingIndicatorContainer>
        </div>
      </div>);
  }
}

MedicalNotes.propTypes = {
  medicalNotes: PropTypes.object.isRequired,
  intl: PropTypes.object,
  dispatch: PropTypes.func,
  patientId: PropTypes.string,
  selectedMedicalNoteId: PropTypes.string,
  totalNumberOfPages: PropTypes.number,
  currentPageNumber: PropTypes.number,
  currentPageUrl: PropTypes.string,
  token: PropTypes.string,
  windowSize: PropTypes.string,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  medicalNotes: state.medicalNotes,
  patientId: state.profile.patient.patientId,
  selectedMedicalNoteId: state.medicalNotes.selectedMedicalNoteId,
  totalNumberOfPages: state.medicalNotes.totalNumberOfPages,
  currentPageNumber: state.medicalNotes.currentPageNumber,
  currentPageUrl: state.medicalNotes.currentPageUrl,
  token: state.profile.auth.access_token,
  windowSize: state.window.size,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(injectIntl(MedicalNotes));